import { useState } from "react";
import { useUserAuthStore } from "../context/useUserAuthStore";

import UsersTab from "../components/tabs/UsersTab";
import SensorsTab from "../components/tabs/SensorsTab";
import VehiclesTab from "../components/tabs/VehiclesTab";
import LinkingTab from "../components/tabs/LinkingTab";
import BookingsTab from "../components/tabs/BookingsTab";

import "../styles/settings.css";

export default function Settings() {
  const [active, setActive] = useState("bookings");
  const { currentUser } = useUserAuthStore();

  const isAdmin = currentUser?.role === "admin";

  const tabs = [
    { key: "bookings", label: "Bookings", show: true },
    { key: "users", label: "Users", show: isAdmin },
    { key: "vehicles", label: "Vehicles", show: true },
    { key: "sensors", label: "Sensor Units", show: isAdmin },
    { key: "linking", label: "Linking", show: isAdmin },
  ];

  // Ensure active tab is allowed
  if (!tabs.find(t => t.key === active && t.show)) {
    const firstAllowed = tabs.find(t => t.show);
    if (firstAllowed) setActive(firstAllowed.key);
  }

  return (
    <div className="settings-root">
      <div className="settings-header">
        <h1>Settings</h1>
        <p>Manage fleet configuration and bookings.</p>
      </div>

      <div className="tabs">
        {tabs.filter(t => t.show).map(t => (
          <button
            key={t.key}
            className={`tab-btn ${active === t.key ? "active" : ""}`}
            onClick={() => setActive(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="tab-panel">
        {active === "users" && <UsersTab />}
        {active === "sensors" && <SensorsTab />}
        {active === "vehicles" && <VehiclesTab />}
        {active === "linking" && <LinkingTab />}
        {active === "bookings" && <BookingsTab />}
      </div>
    </div>
  );
}
